// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.f-indicator[data-v-0c3dd10a] {\n  font-family: var(--font-family);\n}\n", ""]);
// Exports
module.exports = exports;
